module.exports = __webpack_public_path__ + "b302b6e1397e50ad1b8154ec53a144fa.jpg";